export const globalStyles = (props) => ({
  html: { height: '100%', scrollBehavior: 'smooth' },
  body: {
    height: '100%',
    width: '100%',
    [`@media (min-width: ${props.theme.breakpoints.md})`]: {
      width: 'auto',
    },
  },
  '#__next': { height: '100%', isolation: 'isolate' },
  '.grecaptcha-badge': {
    bottom: '100px !important',
  },

  // for some reason, border-colour is added to all elements across the app in the past, this results in issues with shadcn etc where unexpected borders appear
  // leaving it here for reference in case there are release-blockers or prod issues due to previous code relying on this by accident.
  // '*, *::before, *::after': { borderColor: 'gray.400' },

  ':root': {
    '--font-family': props.theme.fonts.body,
  },
  /* Scrollbar styling for scrollable content */

  /* Works on Firefox */
  '.scrollbar-thin *': {
    scrollbarWidth: 'thin',
    scrollbarColor: `${props.theme.colors.primary[200]} transparent`,
  },

  /* Works on Chrome, Edge, and Safari */
  '.scrollbar-thin *::-webkit-scrollbar': {
    width: '4px',
  },

  '.scrollbar-thin *::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },

  '.scrollbar-thin *::-webkit-scrollbar-thumb': {
    backgroundColor: props.theme.colors.primary[200],
    borderRadius: '40px',
  },
  /* End scrollbar styling*/
});
